import { api } from '../../ApiHandler';
import { CompleteUser, RegisterPayload } from '../../../types';

export const RegisterRequest = (
	payload: RegisterPayload,
	captchaToken: string | null,
): Promise<{ data: CompleteUser }> => {
	return api()
		.post('auth/register', payload, {
			headers: {
				'Content-Type': 'application/json',
				'X-CAPTCHA-Token': captchaToken,
			},
		})
		.then(response => response.data);
};
